// extracted by mini-css-extract-plugin
export var activeCover = "shop-module--activeCover--3758d";
export var activeLink = "shop-module--activeLink--9020b";
export var addToCartBtn = "shop-module--addToCartBtn--4ccac";
export var artistLink = "shop-module--artistLink--8c94c";
export var artistListing = "shop-module--artistListing--7b00d";
export var carouselImg = "shop-module--carouselImg--a52ee";
export var carouselSVG = "shop-module--carouselSVG--b26c4";
export var cartNumber = "shop-module--cartNumber--835da";
export var cartSVG = "shop-module--cartSVG--1770c";
export var cartText = "shop-module--cartText--29d70";
export var coverHeading = "shop-module--coverHeading--19b5f";
export var dropdownButton = "shop-module--dropdownButton--30eeb";
export var exhibitionsHeader = "shop-module--exhibitionsHeader--41d08";
export var exhibitionsHeaderContainer = "shop-module--exhibitionsHeaderContainer--387f4";
export var featuredInfo = "shop-module--featuredInfo--2bad2";
export var featuredSlide = "shop-module--featuredSlide--b9d19";
export var featuredSlideInfo = "shop-module--featuredSlideInfo--77d3e";
export var filterButton = "shop-module--filterButton--117c5";
export var filterContainer = "shop-module--filterContainer--6f2fd";
export var filterDropdown = "shop-module--filterDropdown--01caf";
export var filterIndicator = "shop-module--filterIndicator--2afc6";
export var headerLinkContainer = "shop-module--headerLinkContainer--08106";
export var hidden = "shop-module--hidden--1dec7";
export var mediaImage = "shop-module--mediaImage--537ff";
export var nextArrow = "shop-module--nextArrow--faef3";
export var nextArrowProduct = "shop-module--nextArrowProduct--b68e3";
export var previousArrow = "shop-module--previousArrow--eadbe";
export var previousArrowProduct = "shop-module--previousArrowProduct--85a75";
export var productArtist = "shop-module--productArtist--1c4e0";
export var productContainer = "shop-module--productContainer--c1d6a";
export var productCoverContainer = "shop-module--productCoverContainer--aa9e4";
export var productDescription = "shop-module--productDescription--6b72c";
export var productLeft = "shop-module--productLeft--4ab4c";
export var productMediaContainer = "shop-module--productMediaContainer--79c56";
export var productPrice = "shop-module--productPrice--f3adf";
export var productRight = "shop-module--productRight--7aca2";
export var productSizeContainer = "shop-module--productSizeContainer--6e12f";
export var productSizeSelect = "shop-module--productSizeSelect--48ab4";
export var productTilesContainer = "shop-module--productTilesContainer--66922";
export var productTitle = "shop-module--productTitle--3aca1";
export var relatedContainer = "shop-module--relatedContainer--05acf";
export var shopBagButton = "shop-module--shopBagButton--02ae0";
export var shopBagButtonContainer = "shop-module--shopBagButtonContainer--ddf9f";
export var shopSectionHeading = "shop-module--shopSectionHeading--6af01";
export var shopSectionHeadingArtists = "shop-module--shopSectionHeadingArtists--023ef";
export var slideCount = "shop-module--slideCount--9cfcf";
export var slideCountContainer = "shop-module--slideCountContainer--370d5";
export var sliderContainer = "shop-module--sliderContainer--eff04";
export var underCarousel = "shop-module--underCarousel--8b3e1";